const en = {
  register: 'Register for free',
  login: 'Login',
  titleFirst: 'From Scientific Papers',
  titleSecond: 'to Comics in Minutes',
  subtitleFirst: 'Transform Scientific Papers into Engaging Comics with AI.',
  subtitleSecond:
    'Making Scientific Research Accessible Through AI-Generated Comics.',
  source: 'Source',
  sourceDescription: 'Add your comic source and review the selected language.',
  sourceQuestion: 'What do you want to convert?',
  uploadPdf: 'PDF',
  describeTopic: 'Describe comic',
  dropFile: 'Drag your PDF here or click to',
  browse: 'choose a file',
  language: 'I want the comic in:',
  languageSerbian: 'Serbian',
  languageSlovenian: 'Slovene',
  languageEnglish: 'English',
  languageSpanish: 'Spanish',
  languageFrench: 'French',
  languageRussian: 'Russian',
  languageItalian: 'Italian',
  languageChinese: 'Chinese',
  languageTurkish: 'Turkish',
  languageHungarian: 'Hungarian',
  languagePortuguese: 'Portuguese',
  comicType: 'Comic type',
  onePage: 'One page',
  classicFourPanelTemplate: 'Classic four-panel comic',
  classicFourPanelTemplateDescription:
    'A clean one-page layout with a title, four equal images, and captions below each image.',
  templateTitlePlacement: 'Title appears at the top of the page.',
  templateImagePlacement: 'Images are arranged in a 2 by 2 grid.',
  templateTextPlacement: 'Text is placed below each image, not over it.',
  topicPlaceholder: 'Describe the topic ...',
  continue: 'Continue',
  openingLogin: 'Opening login...',
  capabilitiesTitle: 'What can we do for you?',
  researchTitle: 'Turn Research into a Visual Story',
  researchDescription:
    'Upload a scientific paper and turn complex findings into a clear, engaging comic narrative.',
  storyTitle: 'Shape the Story with AI',
  storyDescription:
    'Generate dialogue, refine each message, and choose the language and length that fit your audience.',
  comicTitle: 'Create an Accessible Comic',
  comicDescription:
    'Transform the finished story into a polished comic that makes science easier to understand and share.',
  howTitle: 'How does it work?',
  sourceStepTitle: 'Choose a source',
  sourceStepDescription:
    'Upload a scientific PDF or describe the topic you want to explain.',
  settingsStepTitle: 'Set up your comic',
  settingsStepDescription:
    'Choose the language, length, output format, and comic elements.',
  scriptStepTitle: 'Review the script',
  scriptStepDescription:
    'Edit, rewrite, or regenerate the AI-created frames and dialogue.',
  designStepTitle: 'Choose the visual design',
  designStepDescription:
    'Set the color palette and generate your finished science comic.',
  offersTitle: 'Which offer will you choose?',
  studentsTitle: 'For students',
  studentsDescription:
    'Turn complex research into an engaging comic for projects, presentations, and thesis communication.',
  studentsBenefitOne: 'Pay only when you need it',
  studentsBenefitTwo: 'No monthly subscription',
  studentsBenefitThree: 'Perfect for seminars, theses, and research projects',
  getStarted: 'Get started',
  universitiesTitle: 'For universities',
  universitiesDescription:
    'Make scientific knowledge more accessible and give students and researchers a new way to communicate their work.',
  universitiesBenefitOne: 'Institutional access for students and staff',
  universitiesBenefitTwo: 'Scalable and secure deployment',
  universitiesBenefitThree: 'Onboarding and dedicated support',
  contactUs: 'Contact us',
  footerTagline:
    'We remove friction from academic work, so you can focus on what matters - the science.',
  footerCompany: 'Company',
  footerSolutions: 'Solutions',
  footerServices: 'Services',
  footerContact: 'Contact',
  footerRights: 'All rights reserved.',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Use',
};

export type LandingTranslations = typeof en;

const sr: LandingTranslations = {
  register: 'Registrujte se besplatno',
  login: 'Prijava',
  titleFirst: 'Od naučnih radova',
  titleSecond: 'do stripa za nekoliko minuta',
  subtitleFirst: 'Pretvorite naučne radove u zanimljive stripove pomoću AI.',
  subtitleSecond:
    'Učinite naučna istraživanja pristupačnim kroz stripove generisane pomoću AI.',
  source: 'Izvor',
  sourceDescription: 'Dodajte materijal za strip i proverite izabrani jezik.',
  sourceQuestion: 'Šta želite da pretvorite u strip?',
  uploadPdf: 'PDF',
  describeTopic: 'Opiši strip',
  dropFile: 'Prevucite PDF ovde ili kliknite da',
  browse: 'izaberete fajl',
  language: 'Zelim strip na jeziku:',
  languageSerbian: 'Srpski',
  languageSlovenian: 'Slovenacki',
  languageEnglish: 'Engleski',
  languageSpanish: 'Spanski',
  languageFrench: 'Francuski',
  languageRussian: 'Ruski',
  languageItalian: 'Italijanski',
  languageChinese: 'Kineski',
  languageTurkish: 'Turski',
  languageHungarian: 'Madjarski',
  languagePortuguese: 'Portugalski',
  comicType: 'Tip stripa',
  onePage: 'Jedna strana',
  classicFourPanelTemplate: 'Klasicni strip sa cetiri panela',
  classicFourPanelTemplateDescription:
    'Cist raspored na jednoj strani sa naslovom, cetiri jednake slike i tekstom ispod svake slike.',
  templateTitlePlacement: 'Naslov ide na vrh strane.',
  templateImagePlacement: 'Slike su rasporedjene u mrezi 2 x 2.',
  templateTextPlacement: 'Tekst ide ispod svake slike, ne preko slike.',
  topicPlaceholder: 'Opišite temu ...',
  continue: 'Nastavi',
  openingLogin: 'Otvaranje prijave...',
  capabilitiesTitle: 'Šta možemo da uradimo za vas?',
  researchTitle: 'Pretvorite istraživanje u vizuelnu priču',
  researchDescription:
    'Otpremite naučni rad i pretvorite složene rezultate u jasnu i zanimljivu stripovsku priču.',
  storyTitle: 'Oblikujte priču pomoću AI',
  storyDescription:
    'Generišite dijalog, doradite svaku poruku i izaberite jezik i dužinu prema svojoj publici.',
  comicTitle: 'Napravite pristupačan strip',
  comicDescription:
    'Pretvorite završenu priču u doteran strip koji olakšava razumevanje i deljenje nauke.',
  howTitle: 'Kako funkcioniše?',
  sourceStepTitle: 'Izaberite izvor',
  sourceStepDescription:
    'Otpremite naučni PDF ili opišite temu koju želite da objasnite.',
  settingsStepTitle: 'Podesite strip',
  settingsStepDescription: 'Izaberite jezik, dužinu, format i elemente stripa.',
  scriptStepTitle: 'Pregledajte scenario',
  scriptStepDescription:
    'Izmenite, doradite ili ponovo generišite AI kadrove i dijalog.',
  designStepTitle: 'Izaberite vizuelni dizajn',
  designStepDescription:
    'Podesite paletu boja i generišite završen naučni strip.',
  offersTitle: 'Koju ponudu birate?',
  studentsTitle: 'Za studente',
  studentsDescription:
    'Pretvorite složeno istraživanje u zanimljiv strip za projekte, prezentacije i predstavljanje teze.',
  studentsBenefitOne: 'Platite samo kada vam je potrebno',
  studentsBenefitTwo: 'Bez mesečne pretplate',
  studentsBenefitThree: 'Idealno za seminare, teze i istraživačke projekte',
  getStarted: 'Počnite',
  universitiesTitle: 'Za univerzitete',
  universitiesDescription:
    'Učinite naučno znanje pristupačnijim i omogućite studentima i istraživačima novi način predstavljanja rada.',
  universitiesBenefitOne: 'Institucionalni pristup za studente i zaposlene',
  universitiesBenefitTwo: 'Skalabilna i bezbedna primena',
  universitiesBenefitThree: 'Uvođenje i namenski tim za podršku',
  contactUs: 'Kontaktirajte nas',
  footerTagline:
    'Uklanjamo prepreke iz akademskog rada, da biste mogli da se fokusirate na ono što je važno - nauku.',
  footerCompany: 'Kompanija',
  footerSolutions: 'Rešenja',
  footerServices: 'Usluge',
  footerContact: 'Kontakt',
  footerRights: 'Sva prava zadržana.',
  footerPrivacy: 'Politika privatnosti',
  footerTerms: 'Uslovi korišćenja',
};

const sl: LandingTranslations = {
  register: 'Registrirajte se brezplačno',
  login: 'Prijava',
  titleFirst: 'Od znanstvenih člankov',
  titleSecond: 'do stripa v nekaj minutah',
  subtitleFirst: 'Spremenite znanstvene članke v privlačne stripe z AI.',
  subtitleSecond:
    'Naj bodo znanstvene raziskave dostopne prek stripov, ustvarjenih z AI.',
  source: 'Vir',
  sourceDescription: 'Dodajte gradivo za strip ter preverite izbrani jezik.',
  sourceQuestion: 'Kaj želite spremeniti v strip?',
  uploadPdf: 'PDF',
  describeTopic: 'Opiši strip',
  dropFile: 'Povlecite PDF sem ali kliknite za',
  browse: 'izbiro datoteke',
  language: 'Strip zelim v jeziku:',
  languageSerbian: 'Srbski',
  languageSlovenian: 'Slovenski',
  languageEnglish: 'Angleski',
  languageSpanish: 'Spanski',
  languageFrench: 'Francoski',
  languageRussian: 'Ruski',
  languageItalian: 'Italijanski',
  languageChinese: 'Kitajski',
  languageTurkish: 'Turski',
  languageHungarian: 'Madzarski',
  languagePortuguese: 'Portugalski',
  comicType: 'Vrsta stripa',
  onePage: 'Ena stran',
  classicFourPanelTemplate: 'Klasicni strip s stirimi kadri',
  classicFourPanelTemplateDescription:
    'Cista postavitev na eni strani z naslovom, stirimi enakimi slikami in besedilom pod vsako sliko.',
  templateTitlePlacement: 'Naslov je na vrhu strani.',
  templateImagePlacement: 'Slike so razporejene v mrezi 2 x 2.',
  templateTextPlacement: 'Besedilo je pod vsako sliko, ne cez sliko.',
  topicPlaceholder: 'Opišite temo ...',
  continue: 'Nadaljuj',
  openingLogin: 'Odpiranje prijave...',
  capabilitiesTitle: 'Kaj lahko naredimo za vas?',
  researchTitle: 'Spremenite raziskavo v vizualno zgodbo',
  researchDescription:
    'Naložite znanstveni članek in zapletene ugotovitve spremenite v jasno in privlačno stripovsko zgodbo.',
  storyTitle: 'Oblikujte zgodbo z AI',
  storyDescription:
    'Ustvarite dialog, izboljšajte vsako sporočilo ter izberite jezik in dolžino za svoje občinstvo.',
  comicTitle: 'Ustvarite dostopen strip',
  comicDescription:
    'Dokončano zgodbo spremenite v izpopolnjen strip, ki olajša razumevanje in deljenje znanosti.',
  howTitle: 'Kako deluje?',
  sourceStepTitle: 'Izberite vir',
  sourceStepDescription:
    'Naložite znanstveni PDF ali opišite temo, ki jo želite pojasniti.',
  settingsStepTitle: 'Nastavite strip',
  settingsStepDescription:
    'Izberite jezik, dolžino, izhodni format in elemente stripa.',
  scriptStepTitle: 'Preglejte scenarij',
  scriptStepDescription:
    'Uredite, izboljšajte ali znova ustvarite kadre in dialog z AI.',
  designStepTitle: 'Izberite vizualno podobo',
  designStepDescription:
    'Nastavite barvno paleto in ustvarite dokončan znanstveni strip.',
  offersTitle: 'Katero ponudbo boste izbrali?',
  studentsTitle: 'Za študente',
  studentsDescription:
    'Zapleteno raziskavo spremenite v privlačen strip za projekte, predstavitve in razlago naloge.',
  studentsBenefitOne: 'Plačajte samo takrat, ko potrebujete',
  studentsBenefitTwo: 'Brez mesečne naročnine',
  studentsBenefitThree: 'Odlično za seminarje, naloge in raziskovalne projekte',
  getStarted: 'Začnite',
  universitiesTitle: 'Za univerze',
  universitiesDescription:
    'Naredite znanstveno znanje dostopnejše ter študentom in raziskovalcem ponudite nov način predstavitve dela.',
  universitiesBenefitOne: 'Institucionalni dostop za študente in zaposlene',
  universitiesBenefitTwo: 'Razširljiva in varna uvedba',
  universitiesBenefitThree: 'Uvajanje in namenska podpora',
  contactUs: 'Kontaktirajte nas',
  footerTagline:
    'Odpravljamo ovire pri akademskem delu, da se lahko osredotočite na tisto, kar je pomembno - znanost.',
  footerCompany: 'Podjetje',
  footerSolutions: 'Rešitve',
  footerServices: 'Storitve',
  footerContact: 'Kontakt',
  footerRights: 'Vse pravice pridržane.',
  footerPrivacy: 'Pravilnik o zasebnosti',
  footerTerms: 'Pogoji uporabe',
};

const landingTranslations = { en, sr, sl };

export default landingTranslations;
